<template>
  <div class="mt-2">
    <v-layout>
      <v-flex>
        <v-btn flat @click="cancelProduct">
          <i class="fas fa-chevron-left mr-1"></i>
          {{$t('Back')}}
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn depressed @click="saveProduct" color="primary">{{$t('Save')}}</v-btn>
      </v-flex>
    </v-layout>
    <h3 class="headline mt-3">{{$t('Add new product')}}</h3>

    <div class="pb-3 form-control" :class="{'has-error': errors.has('uploadMultipleFile')}">
      <upload-multiple-file
        v-model="productImages"
        :max="1"
        data-vv-name="uploadMultipleFile"
        data-vv-as="Preview Image"
      ></upload-multiple-file>

      <span
        class="text-error"
        v-show="errors.has('uploadMultipleFile')"
      >{{ errors.first('uploadMultipleFile') }}</span>
    </div>

    <div class="form-control" :class="{'has-error': errors.has('nameInput')}">
      <label class="caption" for="nameInput">{{$t('Product Name')}} *</label>
      <input
        type="text"
        class="form-control"
        ref="name"
        id="nameInput"
        name="nameInput"
        :data-vv-as="$t('Product Name')"
        aria-describedby="name"
        :placeholder="$t('Product Name')"
        v-model="product.name"
        v-validate="'required'"
      />
      <span class="text-error" v-show="errors.has('nameInput')">{{ errors.first('nameInput') }}</span>
    </div>

    <div class="row">
      <div class="col s12"></div>

      <div class="col s12">
        <div class="form-group form-control" :class="{'has-error': errors.has('descriptionInput')}">
          <div>
            <label for="descriptionInput" class="caption">{{$t('Product detail')}} *</label>
          </div>
          <textarea
            type="text"
            class="form-control"
            id="descriptionInput"
            name="descriptionInput"
            style="resize:vertical;min-height: 90px;width: 100%"
            :data-vv-as="$t('Product detail')"
            aria-describedby="description"
            :placeholder="$t('Product detail')"
            row="3"
            v-model="product.description"
            v-validate="'required'"
          ></textarea>
          <span
            class="text-error"
            v-show="errors.has('descriptionInput')"
          >{{ errors.first('descriptionInput') }}</span>
        </div>

        <template v-if="$store.state.specialpage.includes(selectedBot.pageid)">
          <div class="hr" style="margin-top: 35px;"></div>

          <template v-if="$store.getters.getPackage == 'premium'">
            <div class="text-xs-center" style="margin-top: -15px;">
              <a
                class="btn-advanced"
                href="javascript:void(0);"
                @click="showAdvanced = !showAdvanced"
              >
                {{$t('Advanced')}}
                <i
                  class="fa"
                  :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"
                ></i>
              </a>
            </div>

            <template v-if="showAdvanced">
              <div
                class="row form-control"
                :class="{'has-error' : errorTag.length > 0}"
                style="margin-top: 15px;"
              >
                <div class="col s12">
                  <label class="caption" for="keywordInput">{{$t('Keywords')}}</label>
                  <tags
                    v-model="tag"
                    :tags="tags"
                    @tags-changed="newTags => tags = newTags"
                    @before-adding-tag="checkTag"
                  ></tags>
                  <span class="text-error" v-if="errorTag.length > 0">
                    <template v-if="errorTag.includes('duplicate')">{{$t('Duplicate Choice')}}</template>
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col s12 m6">
                  <div
                    class="form-control"
                    v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                  >
                    <label class="caption" for="buttonNameInput">{{$t('Button Name')}}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="buttonNameInput"
                      aria-describedby="Button Name"
                      :placeholder="$t('Button Name')"
                      v-model="product.buttonname"
                    />
                  </div>
                </div>
                <div class="col s12 m6">
                  <div class="form-control" v-if="product.buttonaction == 'url'">
                    <label class="caption" for="buttonUrlInput">{{$t('Product Url')}}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="buttonUrlInput"
                      aria-describedby="Button Url"
                      :placeholder="$t('Product Url')"
                      v-model="product.buttonurl"
                    />
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
    <div class="text-xs-center" v-if="currentView == 'product'">
      <v-btn outline color="grey" @click="cancelProduct">{{$t('cancel')}}</v-btn>
      <v-btn depressed color="primary" @click="saveProduct">{{$t('Save')}}</v-btn>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'

import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'

export default {
  inject: ['$validator'],
  data: function() {
    return {
      currentView: 'product',
      productImages: [],
      product: {
        photourl: null,
        name: null,
        description: null,
        price: 0,
        discountprice: 0,
        currency: 'THB',
        keyword: '',
        code: '',

        buttonaction: 'url',
        buttonname: '',
        buttonurl: '',

        weight: null
      },
      tag: '',
      showAdvanced: false,

      errorTag: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'

          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },

    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join()
      }
    }
  },
  mounted: function() {
    var vm = this
    // vm.$refs.name.focus();

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  components: {
    uploadfile: uploadfile,
    Tags,
    UploadMultipleFile
  },
  methods: {
    cancelProduct: function() {
      this.product = {
        photourl: null,
        name: null,
        description: null,
        price: 0,
        discountprice: 0,
        currency: 'THB',
        keyword: '',
        code: '',

        buttonaction: 'url',
        buttonname: '',
        buttonurl: ''
      }
      this.$emit('close')
    },

    saveProduct: function() {
      let vm = this
      let product = vm.product

      product.currency = 'THB'
      product.price = 0
      product.categoryid = 0
      product.subcategoryid = 0
      product.buttonname = ''
      product.buttonaction = ''
      product.buttonurl = ''

      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        product.pageid = vm.pageid
        product.photourl = vm.productImages.join(';;')
        vm.$store.dispatch('loading')

        api.saveProduct(product, function(error, response) {
          if (error) {
            console.error(error)

            vm.$store.dispatch('loading')
            return
          }
          product.id = response.productid

          vm.productImages = []
          vm.product.id = response.productid
          vm.completeSaveProduct(product)
        })
      })
    },
    completeSaveProduct: function(product) {
      this.$emit('onAddProduct', product)
      this.cancelProduct()
    },
    checkTag: function(obj) {
      this.errorTag = []
      if (this.tags.map(t => t.text).indexOf(obj.tag.text) !== -1) {
        this.errorTag.push('duplicate')
      } else obj.addTag()
    },
    close: function() {
      this.$emit('onAddProduct', this.product)
      //   $("#modal_add_product").modal("hide");
      // this.$store.dispatch('loading')
    }
  },
  watch: {
    'product.price': function(newVal, oldVal) {
      this.product.discountprice = newVal
    }
  }
}
</script>

<style scroped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/hafele/ModalAddProduct.vue